module.exports = __webpack_public_path__ + "img/map-big.4aa59a3a.png";